// extracted by mini-css-extract-plugin
export default {"panel":"iWfv","panelBody":"_3nl8","title":"l1et","primary":"_3CYi"};